import { cn } from '@/lib/utils'
import React from 'react'

export default function StepHeading({ className, ...props }) {
  return (
    <h3
      className={cn(['pb-8 font-bold text-txt-secondary'], className)}
      {...props}
    ></h3>
  )
}
